import { resolve } from "url";

export default {
    methods: {
        init($_day, scrollToTop=true) {
            

            this.loadingPagination = false
            // this.loadingReady = false
            this.fullNotesTopEnd = false // Показываем лоадер заглушки
            this.fullNotesBottomEnd = false // Показываем лоадер
            this.notFullNotes = false
            this.observing(false) // Отписываемся от наблюдателей
            this.showingFullNotes = false
            this.clientNotes = [] // Очищаем заметки
            let _start = this.createDay($_day, -5) // Начало диапозона
            let _end = this.createDay($_day, 5) // Конец диапозона
            this.inViewNote = $_day
            this.topNote = _end // Верхняя заметка
            this.bottomNote = _start// Нижняя заметка
            let _scrDay = null
            switch(scrollToTop) { // Проверяем направление движения 
                case 'today':
                    _scrDay = $_day
                break;
                case true:
                    _scrDay = this.createDay($_day, 1)
                break;
                case false:
                    _scrDay = this.createDay($_day, -1)
                break;
            }
            this.$bus.$emit('showNotesWithFakes')  // Выключаем тумблер в шапке заметок

            this.getNotesByRange(_start, _end).then((data)=>{
                this.clientNotes = { ...data } // Подставляем для отрисовки
                this.loadingPagination = true
                this.$nextTick(() => { 
                    this.scrollToNote(_scrDay, false)
                })
            })
        },
        getNotesByRange(_start, _end) {
            // *** Возвращает хэш карту с заполненными диапозонами *** //
            return new Promise((resolve, reject)=>{
                let _emptyDays = this.fillDatesRange(_start, _end) // Сделали пустую хэш карту по диапозону
                store.dispatch('INIT', { start: _start, end: _end }).then(() => {
                    let _allNotes = store.getters['GET_RANGE_NOTES'] // Получили существующие заметки по диапозону
                    if (_allNotes.length !== 0) { // Если там не пусто
                        _allNotes.map((note) => { 
                            this.filledNotesStorage[note.date] = note // Заполняем хранилище заполненных
                            _emptyDays[note.date] = note // Заполняем диапозон с пустыми
                        })
                    }
                    resolve(_emptyDays)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
        deleteDuplicates(arr) {
            return Array.from(new Set(arr.map(note => note.id))).map(id => {
                return arr.find(note => note.id === id)
            })
        },
        addNote(date, text) {
            store
                .dispatch('WRITE_NOTE', {
                    date: date,
                    text: text
                })
                .then(res => {
                    this.$dmsSuccessNoty(`Заметка с id:${id} удалена`);
                })
                .catch(e => {
                    throw new Error(e);
                });
        },
        createDay(date, direction) {
            // Return a new date
            return moment(date).add(direction, 'days').format('YYYY-MM-DD');
        },
        convertDateToRusFormat(date) {
            return moment(date).format('DD MMM, dddd YYYY ') + 'г.';
        },
        createEmptyDiaryPage(diaryPageDate) {
            // Return a empty diary page object
            return {
                date: diaryPageDate,
                text: ''
            };
        },
        getNextPage() {
            this.observing(false) // Отписываемся от наблюдателей
            let _startofRange = this.createDay(this.topNote, 1) // Начало диапозона
            let _endOfRange = this.createDay(this.topNote, 30) // Конец диапозона
            let _newPortion = this.fillDatesRange(_startofRange, _endOfRange) // Диапозон
            let _ordered = {} // Результирующий
            let _notUsedNotes = {}
            Object.keys(_newPortion).sort((a, b) => {
                if (a > b) {
                    return -1
                } else if (a < b) {
                    return 1
                } else {
                    return 0
                }
            }).map(key => {
                _ordered[key] = {
                    date: key,
                    text: ''
                }
            })
            Object.keys(this.minDateNotesHashMap).map(key => {
                if (!this.minDateNotesHashMap[key].used) {
                    _notUsedNotes[key] = this.minDateNotesHashMap[key] //  Получаем список неиспользованных
                }
            })
            if(Object.keys(_notUsedNotes).length === 0) { // Если нет неиспользованных смотрим есть ли чтото в nextPage - если нет - значит в будущем ничего нет
                if(this.minDateNextPage) { // Если есть след страница
                    this.getNextPageFromMinDate()    
                    return
                } else {
                    this.clientNotes = { ..._ordered, ...this.clientNotes } // Пушим пустые
                }
            } else {
                Object.keys(_notUsedNotes).map(key=>{ // Заполняем заполненными днями
                    if(_ordered[key]) {
                        _ordered[key] = _notUsedNotes[key]
                        this.minDateNotesHashMap[key].used = true
                    }
                })
                this.clientNotes = { ..._ordered, ...this.clientNotes }   
            }
            this.$nextTick(() => {
                this.scrollToNote(_startofRange)
                this.topNote = _endOfRange
            })
        },
        getPrevPage() {
            this.observing(false) //  ОТписываемся от наблюдателей
            let _startOfRange = this.createDay(this.bottomNote, -30) // Начало диапозона
            let _endOfRange = this.createDay(this.bottomNote, -1) // Конец диапозона
            let _newPortion = this.fillDatesRange(_startOfRange, _endOfRange) // Новая порция
            let _ordered = {} // Результирующий
            let _notUsedNotes = {} // Неиспользованнные заметки
            Object.keys(_newPortion).sort((a, b) => {
                if (a > b) {
                    return -1
                } else if (a < b) {
                    return 1
                } else {
                    return 0
                }
            }).map(key => {
                _ordered[key] = {
                    date: key,
                    text: ''
                }
            })

            Object.keys(this.maxDateNotesHashMap).map(key => {
                if (!this.maxDateNotesHashMap[key].used) {
                    _notUsedNotes[key] = this.maxDateNotesHashMap[key] //  Получаем список неиспользованных
                }
            })
            if (Object.keys(_notUsedNotes).length === 0) { // Если нет неиспользованных смотрим есть ли чтото в nextPage - если нет - значит в будущем ничего нет
                if (this.maxDateNextPage) { // Если есть след страница
                    this.getNextPageFromMaxDate()
                    return
                } else {
                    this.clientNotes = { ...this.clientNotes, ..._ordered } // Пушим пустые
                }
            } else {
                Object.keys(_notUsedNotes).map(key => { // Заполняем заполненными днями
                    if (_ordered[key]) {
                        _ordered[key] = _notUsedNotes[key]
                        this.maxDateNotesHashMap[key].used = true
                    }
                })
                this.clientNotes = { ...this.clientNotes, ..._ordered }
            }
            this.$nextTick(() => {
                this.scrollToNote(_endOfRange)
                this.bottomNote = _startOfRange
            })
        },
        getNextPageFromMinDate() {
            // Создает диапозон между заполненными заметками
            store.dispatch('SET_NEXT_PAGE_FOR_MIN_DATE', this.minDateNextPage).then(() => {
                let _notes = store.getters['GET_MIN_DATE_NOTES'];
                let _notesRes = _notes.results
                let _notesHash = {}
                let _out = {}

                _notesRes.map(note => {
                    this.minDateNotesHashMap[note.date] = note; // Добавляем в общий стор
                    this.minDateNotesHashMap[note.date].used = true // Помечаем как использованные
                    _notesHash[note.date] = note
                    this.loadingReady = true
                });
                // Создаем массив дат по диапозону -ф
                let _end = _notesRes[_notesRes.length-1].date
                let _filledRange = this.fillDatesRange(this.topNote, _end)

                // Делаем слияниие в заполненном диапозоне заполняем заметки
                Object.keys(_notesHash).map(function (key) {
                    _filledRange[key] = _notesHash[key];
                });
                Object.keys(_filledRange).sort((a, b) => {
                    if (a > b) {
                        return -1
                    } else if (a < b) {
                        return 1
                    } else {
                        return 0
                    }
                }).map(key=>{
                    _out[key] = _filledRange[key]
                })
                //Рендер
                this.clientNotes = { ..._out, ...this.clientNotes}
                // Scroll
                this.$nextTick(()=>{
                    let _nextDay = this.createDay(this.topNote, 1)
                    this.scrollToNote(_nextDay)
                    this.topNote = _end
                })
                this.minDateNextPage = _notes.next;
            }).catch(e => {
                throw new Error(
                    'action dispatch SET_NEXT_PAGE_FOR_MIN_DATE error ',
                    e
                );
            });
        },
        getNextPageFromMaxDate() {
            store.dispatch('SET_NEXT_PAGE_FOR_MAX_DATE', this.maxDateNextPage).then(() => {
                let _notes = store.getters['GET_MAX_DATE_NOTES'];
                let _notesRes = _notes.results
                let _notesHash = {}
                let _out = {}

                _notesRes.map(note => {
                    this.maxDateNotesHashMap[note.date] = note; // Добавляем в общий стор
                    this.maxDateNotesHashMap[note.date].used = true // Помечаем как использованные
                    _notesHash[note.date] = note
                    this.loadingReady = true
                });
                // Создаем массив дат по диапозону -ф
                let _start = _notesRes[_notesRes.length-1].date
                let _filledRange = this.fillDatesRange(_start, this.bottomNote )
                // Делаем слияниие
                Object.keys(_notesHash).map(function (key) {
                    _filledRange[key] = _notesHash[key];
                });
                Object.keys(_filledRange).sort((a, b) => {
                    if (a > b) {
                        return -1
                    } else if (a < b) {
                        return 1
                    } else {
                        return 0
                    }
                }).map(key => {
                    _out[key] = _filledRange[key]
                })
                // //Рендер
                this.clientNotes = { ...this.clientNotes, ..._out }
                // Scroll
                this.$nextTick(() => {
                    let _nextDay = this.createDay(this.bottomNote, -1)
                    this.scrollToNote(_nextDay)
                    this.bottomNote = _start
                })
                this.maxDateNextPage = _notes.next;
            })
            .catch(e => {
                throw new Error(
                    'action dispatch SET_NEXT_PAGE_FOR_MIN_DATE error ',
                    e
                );
            });
            // } 
            // else {
            //     // this.$dmsSuccessNoty('В прошлом больше нет заметок');
            //     this.topNotesEmpty = false
            //     this.bottomNotesEmpty = true
            //     let _ordered = {}
            //     let _newPortion = this.fillDatesRange(this.createDay(this.bottomNote, -30),this.createDay(this.bottomNote, -2))
            //     let _t = Object.keys(_newPortion).sort((a, b) => {
            //         if (a > b) {
            //             return -1
            //         } else if (a < b) {
            //             return 1
            //         } else {
            //             return 0
            //         }
            //     }).forEach(key => {
            //         _ordered[key] = {
            //             date: key,
            //             text: ''
            //         }
            //     })
            //     this.clientNotes = { ...this.clientNotes, ..._ordered }
            // }
        },
        fillDatesRange(start, end) {
            // @ Возвращает массив заполненный датами
            let _out = []
            let _daysAmount = moment(end).diff(start, 'days', true)
            for (let i = _daysAmount; i >= 0 ; i--) {
                if (i === 0) {
                    _out[start] = {
                        date: start,
                        text: ''
                    }
                    continue
                }
                _out[this.createDay(start, i)] = {
                    date: this.createDay(start, i),
                    text: ''
                }
            }
            return _out
            
        },
        observing(status) {
            // let _topLoader = document.getElementById('topLoader') // Верхний загрузчик
            // let _bottomLoader = document.getElementById('bottomLoader') // Нижний загрузчик
            if(status) {
                // start observing
                this.loadingPagination = true
                let _topLoader = null
                let _bottomLoader = null
                if (this.$refs.topLoader && this.$refs.bottomLoader) {
                    _topLoader = this.$refs.topLoader.$el
                    _bottomLoader = this.$refs.bottomLoader.$el
                }
                this.scrollTopObserver.observe(_topLoader);
                this.scrollDownObserver.observe(_bottomLoader);
            } else {
                this.loadingPagination = false
                // this.scrollTopObserver.disconnect(_topLoader);
                // this.scrollDownObserver.disconnect(_bottomLoader);
            }
            
        }

    },
    mounted() {
        this.$bus.$on('goToToday', () => {
            this.init(this.todayDate);
            this.loadingReady = false
        });
        this.$bus.$on('datePickerInit', date => {
            this.loadingReady = false;
            this.init(date);
        });
        this.$bus.$on('createNote', (createdNote) => {
            // Добавялем id заметки на клиенте
            Object.keys(this.clientNotes).map(key=>{
                if (this.clientNotes[key].date === createdNote.date) {
                    this.clientNotes[key].id = createdNote.id
                }
            })
        })
        this.$bus.$on('showFullNotes', (status) => {
            // Режим отображения заметок
            this.notFullNotes = status
            if (status) {
                // ОТображаем без пустых
                this.initForFullNotes(this.inViewNote, 'today')
            } else {
                // Отображаем в стандартном режиме, сбрасываем 
                this.init(this.inViewNote, 'today')
                // this.loadingReady = true
            }
        }),
        this.$bus.$on('goToSearchedNote', (date) => {
            this.init(date)
        }),
        this.$bus.$on('selectDateOnCalendar', (date) => {
            this.$bus.$emit('searchInit', false)
            this.$bus.$emit('datePickerVisible', false);
            if (this.calendarSyncStatus) {
                // Проверяем есть ли элемент в clientNotes если есть то не делаем новый запрос
                    let _dates = Object.keys(this.clientNotes)
                    if (this.clientNotes[date]) {
                        if (_dates.indexOf(date) === 1 || _dates.indexOf(date) === _dates.length-1) {
                            let _target = this.$refs[date][0].$el
                        _target.scrollIntoView({ block: 'start', behavior: 'smooth'})
                            // this.observing(true)
                            return
                        } 
                        // this.observing(false)
                        let _target = this.$refs[date][0].$el
                        _target.scrollIntoView({ block: 'start', behavior: 'smooth'})
                    } else {
                        this.init(date, 'today')
                    }
                // })
                // this.todayDate = date
                // this.init(date, 'today')
            }
        }),
        this.$bus.$on("calendarSync", (status) => {
            this.calendarSyncStatus = status
        });
        this.$bus.$on('toggleEditorTools', (status) => {
            if (status) {
                document.getElementById('notesList').classList.remove('-hideToolbar')
            } else {
                document.getElementById('notesList').classList.add('-hideToolbar')
            }

        })
        this.$bus.$on('inViewCurrentNote', (date)=>{
            if ( date.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/) ) {
                this.inViewNote = date
            } 
        })
        
    },
    created() {
        const _options = {
            intersectionRatio: '100%'
        }
        this.scrollTopObserver = new IntersectionObserver((entries) => {
            let [entry] = entries;
            if (entry.isIntersecting) {
                setTimeout(() => {
                    this.scrolledToTop()
                    // observer.disconnect()
                }, 100)
            } 
            // else if (entry.isIntersecting && this.showingFullNotes) {
            //     setTimeout(() => {
            //         alert('TOP FULL NOTES')
            //     }, 100)
            // }
        }, _options);
        this.scrollDownObserver = new IntersectionObserver((entries) => {
            let [entry] = entries;
            if (entry.isIntersecting) {
                setTimeout(() => {
                    this.scrolledToDown()
                },100)
                // observer.disconnect()
            } 
            // else if (entry.isIntersecting && this.showingFullNotes) {
            //     setTimeout(()=>{
            //         alert('DOWN FULL NOTES')
            //     },100)
            // }
        }, _options);
    }
}


// WEBPACK FOOTER //
// ./src/apps/bpm/notes/mixins/note.js